/**
 * Operazione Trenta mark — crop-mark frame ("registration corners") around a
 * stamped "30", with a single classified-red tick. Replaces the old airline logo.
 * Kept as `FsLogo` so existing imports keep working.
 */
export default function FsLogo({ size = 96, className = "", title = "Operazione Trenta" }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 48 48"
      fill="none"
      role="img"
      aria-label={title}
      className={className}
      style={{ display: "block", color: "var(--bone)" }}
    >
      {/* Registration / crop-mark corners */}
      <g stroke="currentColor" strokeWidth="1.4" strokeLinecap="square">
        <path d="M3 9V3h6" />
        <path d="M39 3h6v6" />
        <path d="M45 39v6h-6" />
        <path d="M9 45H3v-6" />
      </g>

      {/* Stamped 30 */}
      <text
        x="24"
        y="32"
        textAnchor="middle"
        fontFamily="'Anton', sans-serif"
        fontSize="22"
        letterSpacing="0.5"
        fill="currentColor"
      >
        30
      </text>

      {/* Classified-red tick */}
      <rect x="20.5" y="36.5" width="7" height="2.2" fill="var(--red)" />
    </svg>
  );
}
